/* tslint:disable */
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackFilter,  } from '../../models/BaseModels';
import { JSONSearchParams } from '../core/search.params';
import { ErrorHandler } from '../core/error.service';
import { Observable, Subject } from 'rxjs';
import { Funcionario } from '../../models/Funcionario';


/**
 * Api services for the `Funcionario` model.
 */

export class FuncionarioApi extends BaseLoopBackApi {

  constructor(
     
  ) {
    
    super();
    
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `matricula` – `{string}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Funcionario` object.)
   * </em>
   */
   buscarFuncionarioPersonalNR(matricula, customHeaders) {
    
    let _method = "POST";
    let _url = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/Funcionarios/buscarFuncionarioPersonalNR";
    let _routeParams = {};
    let _postBody = {
      data: {
        matricula: matricula
      }
    };
    let _urlParams = {};
    
    
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }



  /**
   * The name of the model represented by this $resource,
   * i.e. `Funcionario`.
   */
  getModelName() {
    return "Funcionario";
  }
}




// WEBPACK FOOTER //
// ./src/sdk/services/custom/Funcionario.js